/* istanbul ignore file */
import { utils as coreUtils } from '@codegrade/api-core';
import { parsers } from '@codegrade/utils';
const NewAutoTestUncollapsingStepOutputDelaySettingParser = 
/* #__PURE__ */ parsers.object([
    [
        'name',
        /* #__PURE__ */ parsers.exactly('NEW_AUTO_TEST_UNCOLLAPSING_STEP_OUTPUT_DELAY'),
    ],
    ['value', /* #__PURE__ */ parsers.maybeNull(parsers.duration)],
]);
export class NewAutoTestUncollapsingStepOutputDelaySetting extends /* #__PURE__ */ coreUtils.AssigningBase {
    static decode(input) {
        return NewAutoTestUncollapsingStepOutputDelaySettingParser.decode(input).map(res => new NewAutoTestUncollapsingStepOutputDelaySetting(res));
    }
    static unsafeDecode(input) {
        return NewAutoTestUncollapsingStepOutputDelaySetting.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return NewAutoTestUncollapsingStepOutputDelaySettingParser.encode(data);
    }
    static schema() {
        return NewAutoTestUncollapsingStepOutputDelaySettingParser.schema();
    }
}
